<template>
  <CloudPrintDetails
    v-if="cloudprint"
    class="class"
    @click="$router.push({name: 'TaktPlanCloudPrints'})"
    >
    <template #header>
      <v-btn
        icon
        @click="$router.push({name: 'TaktPlanCloudPrints'})"
        >
        <v-icon>
          keyboard_arrow_left
        </v-icon>
      </v-btn>
      <v-spacer/>
      <div>
      <input
        class="ml-2"
        type="textfield"
        :disabled="!edit"
        :value="cloudprint.name"
        :style="`position: relative; width: 100% !important; ${edit?'border-bottom: solid 1px white':''}`"
        @change="updateUObject({
            url: [
              {projects: project_id},
              {cloudprints: cloudprint.id}
            ],
            update: {
              name: $event.target.value
            }
          })"
        style="text-align: center"
      >
      </div>
      <v-spacer/>
      <v-btn
        v-if="hasProjectPermission({
          project_id: $route.params.project_id,
          ppermission: 'Add Trains'
        })"
        small
        :color="edit?'green':''"
        class="mr-1"
        @click="setEdit()"
        >
        {{edit?'done':'edit'}}
      </v-btn>
      <v-btn
        small
        color="red"
        class="mr-1"
        @click="deleteUObject({
          url: [
            {projects: project_id},
            {cloudprints: cloudprint.id}
          ]
        }).then(() => {
          $router.push({name: 'TaktPlanCloudPrints'})
          })"
        >
        Delete
      </v-btn>
    </template>
    <template #body>
      <TFlex class="mt-1 pl-2">
        Description:
      <input
        class="ml-2"
        type="textfield"
        :disabled="!edit"
        :value="cloudprint.description"
        :style="`position: relative; width: 100% !important; ${edit?'border-bottom: solid 1px white':''}`"
        @change="updateUObject({
            url: [
              {projects: project_id},
              {cloudprints: cloudprint.id}
            ],
            update: {
              description: $event.target.value
            }
          })"
      >
    </TFlex>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    Information:
    <TFlex>
    <div style="display: flex; justify-content: center; align-items: center; background-color: white; width: 150px; height: 150px">
      <qrcode-vue :value="`https://takting.com/cloudprints/${cloudprint.link}`" :size="100" level="H" />
    </div>
    <div class="ml-2">
      <input
        id="cloudprint-link"
        readonly="true"
        type="text"
        :value="`https://takting.com/cloudprints/${cloudprint.link}`"
        style="width: 100%"
        />
      <v-btn @click="$router.push({
          name: 'CloudPrintEntryPoint',
          params: {
            cloudprint_link: cloudprint.link
          }
        })"
        >
        open
      </v-btn>
      <v-btn class="ml-4" @click="copyToClipboard()">copy link to clipboard</v-btn>
    </div>
  </TFlex>

  <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
  <TFlex class="mt-1 pl-2">
    <StandardSwitch
      :value="cloudprint.is_public"
      label="Public Print"
      :disabled="!edit"
      @changeValue="updateUObject({
          url: [
            {projects: project_id},
            {cloudprints: cloudprint.id}
          ],
          update: {
            is_public: !cloudprint.is_public
          }
        })"
      />
    <StandardSwitch
      class="ml-10"
      v-if="cloudprint.is_public"
      :value="cloudprint.limit_access_time"
      label="Limit Access Time"
      :disabled="!edit"
      @changeValue="updateUObject({
          url: [
            {projects: project_id},
            {cloudprints: cloudprint.id}
          ],
          update: {
            limit_access_time: !cloudprint.limit_access_time
          }
        })"
      />
      <StandardSwitch
        class="ml-10"
        v-if="cloudprint.is_public"
        :value="show_expires_at"
        label="Expires at"
        :disabled="!edit"
        @changeValue="toggleExpiresAt()"
      />
    </TFlex>
    <template v-if="cloudprint.is_public && cloudprint.limit_access_time">
      <TFlex class="ml-2 mt-2" style="align-items: center">
        <v-btn
        v-for="day in [
          {name: 'Mo', prop: 'monday'},
          {name: 'Tu', prop: 'tuesday'},
          {name: 'We', prop: 'wednesday'},
          {name: 'Th', prop: 'thursday'},
          {name: 'Fr', prop: 'friday'},
          {name: 'Sa', prop: 'saturday'},
          {name: 'Su', prop: 'sunday'},
        ]"
        :key="day.name"
        class="ml-1 mr-1"
        rounded
        :style="`min-width: 0px; width: 36px; margin: 0px; ${!edit?'cursor: default':''}`"
        :color="cloudprint[day.prop]?'blue':''"
        @click="edit?updateUObject({
            url: [
              {projects: project_id},
              {cloudprints: cloudprint.id}
            ],
            update: {
              [day.prop]: !cloudprint[day.prop]
            }
          }):''"
        >
        {{day.name}}
      </v-btn>
      <v-spacer/>
      <input
        type="time"
        :value="cloudprint.start_time"
        :disabled="!edit"
        @change="updateUObject({
            url: [
              {projects: project_id},
              {cloudprints: cloudprint.id}
            ],
            update: {
              start_time: $event.target.value
            }
          })"
        class="grey"
        >
      <div class="ml-2 mr-2"> to</div>
      <input
        type="time"
        :value="cloudprint.end_time"
        :disabled="!edit"
        @change="updateUObject({
            url: [
              {projects: project_id},
              {cloudprints: cloudprint.id}
            ],
            update: {
              end_time: $event.target.value
            }
          })"
        class="grey"
        >
      <v-spacer/>
    </TFlex>
    </template>
    <template v-if="cloudprint.is_public && show_expires_at">
      <StandardDateSelector
        @input="updateUObject({
          url: [
            {projects: project_id},
            {cloudprints: cloudprint.id}
          ],
          update: {
            expires_at: `${$event} 12:00:00`
          }
        })"
        :value="cloudprint.expires_at"
        first_day_of_week="Mo"
        persistant="false"
      />
    </template>
  <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>


  <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
  <div>Statistic Settings</div>
  <template v-if="location === 'ProjectTaktPlan'">
    <TFlex align_items="center">
    <StandardOverflowButton
      ref="statisticSettingsCloudPrintDetail"
      tooltip="value"
      ticon="takt-plan-workpackage"
      :click_to_open="true"
      :value="{value: cloudprint.settings.statistic_settings.value}"
      :options="{value: [
          {value: 'workpackages', ticon: 'takt-plan-workpackage', icon: 'dns', tooltip: 'Number of WORK.packages'},
          {value: 'time_effort_planned', ticon: 'speedometer', icon: 'speed', tooltip: 'Planned time effort'},
          {value: 'manpower_planned', ticon: 'person-standing', icon: 'accessibility', tooltip: 'Planned manpower'},
          {value: 'duration_planned', ticon: 'stopwatch', icon: 'timer', tooltip: 'Duration planned'},
          {value: 'time_effort_actual', ticon: 'speedometer', icon: 'speed', tooltip: 'Actual time effort'},
          {value: 'manpower_actual', ticon: 'person-standing', icon: 'accessibility', tooltip: 'Actual manpower'},
          {value: 'duration_actual', ticon: 'stopwatch', icon: 'timer', tooltip: 'Actual duration'},
          {value: 'twork_step_count', ticon: $store.state.Ultra.step_icons['work'], icon: 'list', tooltip: 'Number of WORK.steps'},
          {value: 'tdesign_step_count', ticon: $store.state.Ultra.step_icons['design'], icon: 'design_services', tooltip: 'Number of DESIGN.steps'},
          {value: 'tlogistic_step_count', ticon: $store.state.Ultra.step_icons['logistic'], icon: 'airport_shuttle', tooltip: 'Number of LOGISTIC.steps'},
          {value: 'tquality_step_count', ticon: $store.state.Ultra.step_icons['quality'], icon: 'high_quality', tooltip: 'Number of QUALITY.steps'},
          {value: 'tdefect_step_count', ticon: $store.state.Ultra.step_icons['defect'], icon: 'broken_image', tooltip: 'Number of DEFECT.steps'},
          {value: 'thandover_step_count', ticon: $store.state.Ultra.step_icons['handover'], icon: 'sync_alt', tooltip: 'Number of HANDOVER.steps'},
          {value: 'image_count', ticon: 'image', icon: 'photo', tooltip: 'Number of images'},
          {value: 'log_entry_count', ticon: 'clipboard-pencil', icon: 'book', tooltip: 'Number of LOG.entries'},
          {value: 'costs_budget_labour', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Labour budget'},
          {value: 'costs_budget_material', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Material budget'},
          {value: 'costs_paid_out_labour', ticon: 'money', icon: 'payments', tooltip: 'Labour paid out'},
          {value: 'costs_paid_out_material', ticon: 'money', icon: 'payments', tooltip: 'Material paid out'},
          {value: 'costs_paid_tendered_labour', ticon: 'shopping-cart', icon: 'shopping_cart', tooltip: 'Labour tendered'},
          {value: 'costs_paid_tendered_material', ticon: 'shopping-cart', icon: 'shopping_cart', tooltip: 'Material tendered'},
          {value: 'calendar', ticon: 'calendar', icon: 'calendar_today', tooltip: 'Calendar'},
        ]}"
      @select-option="updateCloudPrintSettingsTP($event.setting, $event.value)"
      style="position: relative; width: 100%; overflow: auto"
      :disabled="!edit"
      />
    </TFlex>
    <TFlex align_items="center">
    <StandardOverflowButton
      ref="statisticSettingsCumulativeCloudPrintDetail"
      tooltip="cumulative"
      ticon="poll"
      :click_to_open="true"
      :value="{cumulative: cloudprint.settings.statistic_settings.cumulative}"
      :options="[
        'manpower_planned',
        'manpower_actual',
        'time_effort_planned',
        'time_effort_actual',
        'calendar',
        ].includes(cloudprint.settings.statistic_settings.value)?
        {cumulative: [
          {value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Cumulative'},
        ]}
        :
        {cumulative: [
          {value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Per TAKT.time'},
          {value: true, ticon: 'ascending', icon: 'signal_cellular_alt', tooltip: 'Cumulative'}
        ]}
      "
      @select-option="updateCloudPrintSettingsTP($event.setting, $event.value)"
      style="position: relative; width: 100%; overflow: auto"
      :disabled="!edit"
      />
    </TFlex>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    <TFlex align_items="center">
    <div>Filter Settings: </div>
    <StandardOverflowButton
      ref="filterCloudPrintDetail"
      tooltip="Filter Settings"
      :click_to_open="true"
      icon="filter_alt"
      ticon="filter"
      :multiselect="true"
      :button_color="cloudprint.settings.statistic_settings.filter? 'color-3':''"
      :value="{
        icons: cloudprint.settings.statistic_settings.icons,
        colors: cloudprint.settings.statistic_settings.colors,
        status: cloudprint.settings.statistic_settings.status,
        trains: cloudprint.settings.statistic_settings.trains
        }"
      :options="{
        icons: getTWorkpackageIcons,
        colors: getTWorkpackageColors,
        status: getFullStatusArray,
        trains: getStatisticsTrainSelector(project_id),
        }
        "
      @select-option="updateCloudPrintFilterTP($event.setting, $event.value)"
      :disabled="!edit"
      />
      </TFlex>
      <div v-if="!cloudprint.settings.statistic_settings.filter">No filter</div>
      <template v-if="cloudprint.settings.statistic_settings.filter">
        <div>icons: {{cloudprint.settings.statistic_settings.icons}}</div>
        <div>colors: {{cloudprint.settings.statistic_settings.colors}}</div>
        <div>status: {{cloudprint.settings.statistic_settings.status}}</div>
        <div>trains: {{cloudprint.settings.statistic_settings.trains}}</div>
      </template>
    <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>

    <div>Open Trains:</div>
    <div v-for="train_id in cloudprint.settings.trains_open"
      :key="train_id"
      >
      {{getUObject({type: 'trains', id: train_id}).name}}
    </div>
  </template>
  <v-divider class="mt-2 mb-2" color="white" width="100%"></v-divider>
    </template>
  </CloudPrintDetails>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  import QrcodeVue from 'qrcode.vue'

  import CloudPrintDetails from '@/components/CloudPrint/CloudPrintDetails.component.vue'
  import TFlex from '@/components/Taktify/TFlex.component.vue'
  import StandardSwitch from '@/components/StandardComponents/StandardSwitch.component.vue'
  import StandardOverflowButton from '@/components/StandardComponents/StandardOverflowButton.component.vue'
  import StandardDateSelector from '@/components/StandardComponents/StandardDateSelector.component.vue'

  export default {
    props: ['cloudprint', 'project_id', 'location'],
    components: {
      CloudPrintDetails,
      QrcodeVue,
      TFlex,
      StandardSwitch,
      StandardOverflowButton,
      StandardDateSelector,
    },
    data: () => ({
      edit: false,
      show_expires_at: false,
    }),
    created(){
      if (this.cloudprint && this.cloudprint.expires_at !== null) {
        this.show_expires_at = true;
      }
    },
    computed: {
      ...mapGetters('Project', [
        'getFullStatusArray',
        'getStatisticsTrainSelector',
        'hasProjectPermission',
      ]),
      ...mapGetters('TWorkPackage', [
        'getTWorkpackageIcons',
        'getTWorkpackageColors',
      ]),
      ...mapGetters('Ultra', [
        'getUObject',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'deleteUObject',
        'updateUObject',
      ]),
      copyToClipboard() {
        var copyText = document.getElementById("cloudprint-link");
        copyText.select();
        document.execCommand("copy");
      },
      updateCloudPrintSettingsTP(setting, value) {
        let settings = JSON.parse(JSON.stringify(this.cloudprint.settings));
        settings.statistic_settings[setting] = value;
        this.updateUObject({
          url: [
            {projects: this.project_id},
            {cloudprints: this.cloudprint.id}
          ],
          update: {
            settings: settings
          }
        })
      },
      setEdit(){
        this.edit = !this.edit;
        this.$refs.statisticSettingsCloudPrintDetail.closeFilter();
        this.$refs.statisticSettingsCumulativeCloudPrintDetail.closeFilter();
        this.$refs.filterCloudPrintDetail.closeFilter();
      },
      toggleExpiresAt(){
        if (this.show_expires_at) {
          this.updateUObject({
          url: [
            {projects: this.project_id},
            {cloudprints: this.cloudprint.id}
          ],
          update: {
            expires_at: null
          }
        });
          this.show_expires_at = false;
        } else {
          this.show_expires_at = true;
        }
      },
      updateCloudPrintFilterTP(setting, value) {
       let settings = JSON.parse(JSON.stringify(this.cloudprint.settings));
       let index = settings.statistic_settings[setting].indexOf(value)
       if (index === -1) {
         settings.statistic_settings[setting].push(value);
       } else {
         settings.statistic_settings[setting].splice(index, 1);
       }
       if (settings.statistic_settings.icons.length === 0 &&
          settings.statistic_settings.colors.length === 0 &&
          settings.statistic_settings.trains.length === 0 &&
          settings.statistic_settings.status.length === 0
       ) {
         settings.statistic_settings.filter = false;
       } else {
         settings.statistic_settings.filter = true;
       }
       this.updateUObject({
         url: [
           {projects: this.project_id},
           {cloudprints: this.cloudprint.id}
         ],
         update: {
           settings: settings
         }
       })
      }
    }
  }
</script>
<style>
  .class {

  }
</style>
